import { render, staticRenderFns } from "./category-dialog.vue?vue&type=template&id=929c26cc&scoped=true"
import script from "./category-dialog.vue?vue&type=script&lang=js"
export * from "./category-dialog.vue?vue&type=script&lang=js"
import style0 from "./category-dialog.vue?vue&type=style&index=0&id=929c26cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929c26cc",
  null
  
)

export default component.exports